import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChamadosListClienteComponent } from './components/chamados-list-cliente/chamados-list-cliente.component';

const routes: Routes = [{ path: '', component: ChamadosListClienteComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChamadosClienteRoutingModule { }
